import React from 'react'

export interface Theme {
    tableVersion? : boolean,
    homeTopImage? : string,
    backgroundImage? : string,
    diplomaImage? : string,
    helperImage? : string,
}

const ThemeContext = React.createContext<Theme>(undefined)

export const ThemeProvider = ThemeContext.Provider

export default ThemeContext